import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "../components/Reveal";
import { scrollToId } from "../lib/scroll";

export const Pricing = () => (
  <section id="prezzi" aria-labelledby="prezzi-title" className="bg-mist">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-28">
      <Reveal>
        <div className="mx-auto max-w-3xl text-center">
          <SectionLabel>Investimento</SectionLabel>
          <h2 id="prezzi-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-navy-dark sm:text-4xl">
            Un progetto costruito sulle tue esigenze.
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-steel sm:text-lg">
            Il costo dipende dalla struttura del sito, dai contenuti e dalle funzionalità richieste.
            Prima di iniziare riceverai una proposta chiara con caratteristiche e costo del progetto.
          </p>
          <a
            href="#contatti"
            onClick={(e) => { e.preventDefault(); scrollToId("#contatti"); }}
            data-testid="pricing-cta"
            className="group mt-9 inline-flex items-center gap-2 rounded-lg bg-navy px-8 py-3.5 text-base font-semibold text-white shadow-md transition-all duration-200 hover:bg-navy-dark hover:shadow-lg active:scale-[0.98]"
          >
            Raccontaci cosa ti serve
            <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
